// extracted by mini-css-extract-plugin
export default {"mainContainer":"header_mainContainer__aMfEb"};